import React from 'react';
import css from './SectionAppPromotion.module.css'; // Adjust the import path as necessary
import { FormattedMessage } from '../../../../util/reactIntl';

const SectionAppPromotion = () => {
    return (
        <section className={css.purpleBackground}>
            <div className={css.container}>
                <div className={css.leftContent}>
                    {/* iPhone image as a container for the video */}
                    <div className={css.iphoneWrapper}>
                        <video
                            className={css.screenRecording}
                            src="https://s3.amazonaws.com/webflow-prod-assets/641234196da95de0da5f4ec7/650852d43c3c6d169cd5b59d_Young%20Loved.mp4" // Replace with your video source
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                        <img 
                            src="/static/images/iphone.png" // Replace with your iPhone image source
                            alt="iPhone"
                            className={css.iphoneImage}
                        />
                    </div>
                </div>
                <div className={css.rightContent}>
                    <div className={css.textContainer}>
                        <h4 className={css.title}>
                            <FormattedMessage id="LandingPage.newSectionTitle" defaultMessage="We’re your pocket solution to buying and selling your family’s preloved gems." />
                        </h4>
                        <p className={css.subtitle}>
                            <FormattedMessage id="LandingPage.newSectionSubtitle" defaultMessage="Download the Young Loved App and join our mission in being proud to be preloved." />
                        </p>
                    <div className={css.buttons}>
                      <a
                        href="https://apps.apple.com/nl/app/young-loved/id6464721037?l=en-GB"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={css.buttonLink}
                      >
                        <button className={css.buttonPrimary}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" className={css.iconApple}>
                            <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" className={css.iconPath} />
                          </svg>
                          <FormattedMessage id="LandingPage.appleButton" />
                        </button>
                      </a>

                      <a
                        href="https://play.google.com/store/apps/details?id=com.youngloved"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={css.buttonLink}
                      >
                        <button className={css.buttonSecondary}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className={css.iconAndroid}>
                            <path d="M420.6 301.9a24 24 0 1 1 24-24 24 24 0 0 1 -24 24m-265.1 0a24 24 0 1 1 24-24 24 24 0 0 1 -24 24m273.7-144.5 47.9-83a10 10 0 1 0 -17.3-10h0l-48.5 84.1a301.3 301.3 0 0 0 -246.6 0L116.2 64.5a10 10 0 1 0 -17.3 10h0l47.9 83C64.5 202.2 8.2 285.6 0 384H576c-8.2-98.5-64.5-181.8-146.9-226.6" className={css.iconPath} />
                          </svg>
                          <FormattedMessage id="LandingPage.androidButton" />
                        </button>
                      </a>
                    </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SectionAppPromotion;
